import { useTranslation } from 'react-i18next';

const SOURCE_COLORS: Record<string, string> = {
  BRAND_UPLOADED: 'bg-copper/10 text-copper border-copper/30',
  BRAND_BULK_CSV: 'bg-copper/20 text-copper border-copper/40',
  DEMO_SEED: 'bg-slate-100 text-slate-500 border-slate-200',
  AI_EXTRACTED_FROM_MEMO: 'bg-amber-100 text-amber-800 border-amber-200',
  LEGACY_IMPORT: 'bg-slate-100 text-slate-400 border-slate-200',
};

// Inline sparkles SVG — no lucide-react dependency
function SparklesIcon() {
  return (
    <svg className="mr-1 inline" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
      <path d="M20 3v4"/>
      <path d="M22 5h-4"/>
      <path d="M4 17v2"/>
      <path d="M5 18H3"/>
    </svg>
  );
}

export function SourceBadge({ sourceType }: { sourceType: string }) {
  const { t } = useTranslation();
  const label = t(`approver.review.sourceBadge.${sourceType}`, { defaultValue: sourceType });
  const cls = SOURCE_COLORS[sourceType] ?? 'bg-slate-100 text-slate-500 border-slate-200';

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded border text-[11px] font-semibold ${cls}`}>
      {sourceType === 'BRAND_UPLOADED' && <span className="mr-1">✓</span>}
      {sourceType === 'AI_EXTRACTED_FROM_MEMO' && <SparklesIcon />}
      {label}
    </span>
  );
}
